import { Navigate } from 'react-router';
import { useAuth } from '../../lib/auth';

export default function StaffLogin() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-[var(--vivid-purple)] border-t-transparent" />
      </div>
    );
  }

  const isStaffOrPartner = user?.is_staff || (user?.partner_ids && user.partner_ids.length > 0);

  // Already logged in as staff/partner → go to staff area
  if (isStaffOrPartner) {
    return <Navigate to="/staff" replace />;
  }

  // Not logged in or not staff → go to unified login
  return <Navigate to="/cont" replace />;
}
